/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateFragmentSocialUploadsMutationRequest, WebAppCreateFragmentSocialUploadsMutationResponse, WebAppCreateFragmentSocialUploads401, WebAppCreateFragmentSocialUploads403 } from "../models/WebAppCreateFragmentSocialUploads";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateFragmentSocialUploads } from "../axios/webAppCreateFragmentSocialUploads";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateFragmentSocialUploadsMutationKey = () => [{ url: '/web-app/v1/fragment-social-uploads' }] as const

export type WebAppCreateFragmentSocialUploadsMutationKey = ReturnType<typeof webAppCreateFragmentSocialUploadsMutationKey>

export function webAppCreateFragmentSocialUploadsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateFragmentSocialUploadsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateFragmentSocialUploadsMutationKey()
        return mutationOptions<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<WebAppCreateFragmentSocialUploads401 | WebAppCreateFragmentSocialUploads403>, {data: WebAppCreateFragmentSocialUploadsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return webAppCreateFragmentSocialUploads(data, config)
          },
        })

}

/**
 * @summary Start upload of fragment or video-editor project media to platform
 * {@link /web-app/v1/fragment-social-uploads}
 */
export function useWebAppCreateFragmentSocialUploads<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<WebAppCreateFragmentSocialUploads401 | WebAppCreateFragmentSocialUploads403>, {data: WebAppCreateFragmentSocialUploadsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateFragmentSocialUploadsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateFragmentSocialUploadsMutationKey()

          const baseOptions = webAppCreateFragmentSocialUploadsMutationOptions(config) as UseMutationOptions<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<WebAppCreateFragmentSocialUploads401 | WebAppCreateFragmentSocialUploads403>, {data: WebAppCreateFragmentSocialUploadsMutationRequest}, TContext>
          

          return useMutation<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<WebAppCreateFragmentSocialUploads401 | WebAppCreateFragmentSocialUploads403>, {data: WebAppCreateFragmentSocialUploadsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<WebAppCreateFragmentSocialUploads401 | WebAppCreateFragmentSocialUploads403>, {data: WebAppCreateFragmentSocialUploadsMutationRequest}, TContext>
      
}